import React, { useState } from "react";
import { showErrorToast, showSuccessToast } from "../../../assets/toastUtils";
import { Link, useNavigate, useParams } from "react-router-dom";
import VendorHeader from "../../../CustomComponents/Property/VendorHeader/VendorHeader";
import SideBar from "../../../CustomComponents/Property/SideBar/SideBar";
import styles from "./VendorPropertyHelp.module.scss";
import supportIcon from "../../../assets/new-images/support-new.png";
import AgentSideBar from "../../Agent/AgentSideBar/AgentSideBar";
import AgentHeader from "../../Agent/AgentHeader/AgentHeader";

function AgentHelpPage({ setPropertyData }) {
  const navigate = useNavigate();
  const [formErrors, setFormErrors] = useState({});
  const { id } = useParams();
  const vendorToken = localStorage.getItem("token");

  const faqs = [
    {
      question: "How can I register as a travel agent on Mountain Mysteries?",
      answer:
        "To register as a travel agent with Mountain Mysteries, simply fill out the online registration form with your business and contact details. Once submitted, your application will be reviewed. Upon verification and once your profile reaches 100% completion, you will receive full access to your agent account.",
    },
    {
      question:
        "What are the benefits of becoming a travel agent partner with Mountain Mysteries?",
      answer:
        "Registered agents receive access to exclusive B2B travel rates, specially curated travel packages, discounted accommodations and transport services, and promotional deals. In addition, you benefit from commission-based earnings and priority customer support.",
    },
    {
      question: "Why do I need to complete my agent profile to 100%?",
      answer:
        "A fully completed profile is necessary to activate your account and access all features of the platform. This includes booking tools, client management, commission tracking, and personalized support. It also ensures compliance and helps us deliver better services to our agent network.",
    },
    {
      question: "How does the commission structure work for agents?",
      answer:
        "As a partner agent, you earn commission on every qualifying booking made through your account. The system automatically calculates your commission, which is added to your earnings record. Payouts are processed based on a defined schedule and can be tracked transparently.",
    },
    {
      question: "Are there exclusive deals available to agents?",
      answer:
        "Yes, agents have access to limited-time promotions, seasonal discounts, and special deals created specifically for the travel trade. These offers help you increase profitability and provide added value to your customers.",
    },
    {
      question: "Can I create customized packages for my clients?",
      answer:
        "Yes, the platform enables you to build customized itineraries by combining travel products such as hotel stays, local activities, transport services, and guided tours. This flexibility allows you to design trips that align with your clients’ needs and preferences.",
    },
    {
      question:
        "What should I do if I face login issues or encounter a problem with a booking?",
      answer:
        "If you experience any difficulties with login, account access, or booking errors, our support team is available 24/7 to assist. You can reach out for quick resolutions and guidance whenever needed.",
    },
    {
      question:
        "Will I receive training or onboarding assistance as a new agent?",
      answer:
        "Yes, new agents are provided with onboarding support, including usage guides, walkthroughs, and personalized assistance if required. This ensures that you are fully equipped to use the system efficiently and maximize your sales potential.",
    },
    {
      question: "Can I store and manage my client data through the platform?",
      answer:
        "Yes, the system allows you to maintain customer profiles, including contact information, travel history, preferences, and special notes. This helps with client relationship management and follow-ups for future trips.",
    },
    {
      question:
        "Is there any minimum number of bookings required to stay active?",
      answer:
        "There is no minimum booking requirement to remain active, but regular engagement may unlock higher commission slabs, special privileges, and faster support. Consistency also helps improve your visibility on the platform.",
    },
  ];

  const [activeIndex, setActiveIndex] = useState(0);
  const toggleFAQ = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  return (
    <section>
      <div className="sidebar_main_div new_sidebar_main_div">
        <AgentSideBar />

        <div className="agent-info-container">
          <AgentHeader showSelectProperty={true} vendorProperty={false} />

          <section
            className="w-full"
            style={{ borderRadius: "10px", marginTop: "10px" }}
          >
            <div id="common_bg m_20">
              <div className="mt-20">
                <div className={styles.vendor_property_help}>
                  <div className={styles.vendor_property_help_left}>
                    <div className={styles.contactCard}>
                      <div className={styles.imageSection}>
                        <img src={supportIcon} alt="Contact Illustration" />
                      </div>
                      <div className={styles.contentSection}>
                        <h2>Contact Support</h2>
                        <Link to="tel:+919816633966" className={styles.info}>
                          {" "}
                          <svg
                            width="18"
                            height="19"
                            viewBox="0 0 18 19"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <mask
                              id="mask0_7312_12205"
                              style={{ maskType: "alpha" }}
                              maskUnits="userSpaceOnUse"
                              x="0"
                              y="0"
                              width="18"
                              height="19"
                            >
                              <rect
                                y="0.5"
                                width="18"
                                height="18"
                                fill="#D9D9D9"
                              />
                            </mask>
                            <g mask="url(#mask0_7312_12205)">
                              <path
                                d="M14.5802 15.875C13.1668 15.875 11.7469 15.5464 10.3204 14.8891C8.894 14.2319 7.58225 13.3048 6.38513 12.1077C5.19288 10.9106 4.26813 9.6 3.61088 8.17588C2.95363 6.75188 2.625 5.33319 2.625 3.91981C2.625 3.69481 2.7 3.50606 2.85 3.35356C3 3.20119 3.1875 3.125 3.4125 3.125H5.85862C6.048 3.125 6.21506 3.18681 6.35981 3.31044C6.50456 3.43394 6.59663 3.58656 6.636 3.76831L7.06594 5.975C7.09569 6.17975 7.08944 6.35569 7.04719 6.50281C7.00481 6.64994 6.92881 6.7735 6.81919 6.8735L5.08706 8.55969C5.36581 9.07019 5.68431 9.55313 6.04256 10.0085C6.40069 10.4638 6.78844 10.8986 7.20581 11.3129C7.61731 11.7246 8.05481 12.1068 8.51831 12.4597C8.98181 12.8126 9.48231 13.1409 10.0198 13.4448L11.7028 11.7472C11.8202 11.6251 11.9623 11.5394 12.1292 11.4903C12.2959 11.4413 12.4693 11.4293 12.6491 11.4543L14.7317 11.8784C14.9211 11.9284 15.0756 12.0251 15.1954 12.1683C15.3151 12.3116 15.375 12.4741 15.375 12.6558V15.0875C15.375 15.3125 15.2988 15.5 15.1464 15.65C14.9939 15.8 14.8052 15.875 14.5802 15.875Z"
                                fill="#009A50"
                              />
                            </g>
                          </svg>
                          <span>+91 98166 33966</span>
                        </Link>
                        <Link
                          to="mailto:info@mountainmysteries.com"
                          className={styles.info}
                        >
                          <svg
                            width="18"
                            height="19"
                            viewBox="0 0 18 19"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <mask
                              id="mask0_7312_12211"
                              style={{ maskType: "alpha" }}
                              maskUnits="userSpaceOnUse"
                              x="0"
                              y="0"
                              width="18"
                              height="19"
                            >
                              <rect
                                y="0.5"
                                width="18"
                                height="18"
                                fill="#D9D9D9"
                              />
                            </mask>
                            <g mask="url(#mask0_7312_12211)">
                              <path
                                d="M3.23081 15.125C2.85194 15.125 2.53125 14.9938 2.26875 14.7313C2.00625 14.4688 1.875 14.1481 1.875 13.7692V5.23081C1.875 4.85194 2.00625 4.53125 2.26875 4.26875C2.53125 4.00625 2.85194 3.875 3.23081 3.875H14.7692C15.1481 3.875 15.4688 4.00625 15.7313 4.26875C15.9938 4.53125 16.125 4.85194 16.125 5.23081V13.7692C16.125 14.1481 15.9938 14.4688 15.7313 14.7313C15.4688 14.9938 15.1481 15.125 14.7692 15.125H3.23081ZM9 9.79419C9.0625 9.79419 9.1245 9.78481 9.186 9.76606C9.24762 9.74731 9.30725 9.72162 9.36487 9.689L14.7289 6.25475C14.8144 6.20187 14.8749 6.13338 14.9106 6.04925C14.9462 5.96513 14.9567 5.87644 14.9423 5.78319C14.9326 5.61006 14.848 5.48144 14.6884 5.39731C14.5289 5.31319 14.3679 5.32063 14.2054 5.41963L9 8.75L3.79463 5.41963C3.63213 5.32063 3.47231 5.31269 3.31519 5.39581C3.15794 5.47906 3.07212 5.60575 3.05775 5.77588C3.04325 5.87688 3.05381 5.97063 3.08944 6.05713C3.12506 6.14375 3.18563 6.20962 3.27113 6.25475L8.63513 9.689C8.69275 9.72162 8.75238 9.74731 8.814 9.76606C8.8755 9.78481 8.9375 9.79419 9 9.79419Z"
                                fill="#009A50"
                              />
                            </g>
                          </svg>
                          <span>info@mountainmysteries.com</span>
                        </Link>
                      </div>
                    </div>
                  </div>
                  <div className={styles.vendor_property_help_right}>
                    <div className={styles.faqWrapper}>
                      <h2>FAQs</h2>
                      <div className={styles.faqList}>
                        {faqs.map((faq, index) => (
                          <div
                            key={index}
                            className={`${styles.faqItem} ${
                              activeIndex === index ? styles.active : ""
                            }`}
                          >
                            <div
                              className={styles.faqHeader}
                              onClick={() => toggleFAQ(index)}
                            >
                              <span>{faq.question}</span>
                              <button>
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="18"
                                  height="18"
                                  viewBox="0 0 18 18"
                                  fill="none"
                                  style={{
                                    transform:
                                      activeIndex === index
                                        ? "rotate(180deg)"
                                        : "rotate(0deg)",
                                    transition: "transform 0.3s ease",
                                  }}
                                >
                                  <mask
                                    id="mask0_7312_12027"
                                    maskUnits="userSpaceOnUse"
                                    x="0"
                                    y="0"
                                    width="18"
                                    height="18"
                                  >
                                    <rect
                                      y="18"
                                      width="18"
                                      height="18"
                                      transform="rotate(-90 0 18)"
                                      fill="#D9D9D9"
                                    />
                                  </mask>
                                  <g mask="url(#mask0_7312_12027)">
                                    <path
                                      d="M8.99824 11.111L14.6478 5.46146C14.7968 5.31246 14.9722 5.23984 15.1741 5.24359C15.3761 5.24746 15.5516 5.3239 15.7006 5.4729C15.8496 5.62202 15.9241 5.79752 15.9241 5.9994C15.9241 6.20127 15.8496 6.37677 15.7006 6.5259L9.9588 12.2791C9.82318 12.4148 9.67124 12.5153 9.50299 12.5806C9.33474 12.646 9.16649 12.6787 8.99824 12.6787C8.82999 12.6787 8.66174 12.646 8.49349 12.5806C8.32524 12.5153 8.1733 12.4148 8.03768 12.2791L2.28424 6.5259C2.13524 6.37677 2.06268 6.19934 2.06655 5.99359C2.07043 5.78784 2.14687 5.61046 2.29587 5.46146C2.44487 5.31246 2.62037 5.23796 2.82237 5.23796C3.02424 5.23796 3.19968 5.31246 3.34868 5.46146L8.99824 11.111Z"
                                      fill="#1C1B1F"
                                    />
                                  </g>
                                </svg>
                              </button>
                            </div>
                            {activeIndex === index && (
                              <div className={styles.faqContent}>
                                <p>{faq.answer}</p>
                              </div>
                            )}
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </section>
  );
}
export default AgentHelpPage;
